<template>
  <div class="my-events-container collapsible-section">
    <h3 @click="toggleOpen" class="collapsible-header">
      Evenimentele Mele Viitoare
      <span>{{ isOpen ? '▲' : '▼' }}</span>
    </h3>
    
    <div v-if="isOpen" class="collapsible-content">
      <div v-if="loading">Se încarcă evenimentele tale...</div>
      
      <div v-if="error" class="error">{{ error }}</div>
      
      <ul v-if="events.length > 0" class="event-list">
        <li v-for="event in events" :key="event.id" class="event-item">
          <h4>{{ event.title }}</h4>
          <p><strong>Locație:</strong> {{ event.location }}</p>
          <p><strong>Începe:</strong> {{ formatData(event.start_time) }}</p>
          
          <div v-if="event.confirmation_status === 'attended'">
            <p><strong>Status:</strong> <span class="status-attended">Prezență Confirmată</span></p>
          </div>

          <div v-else>
            <p><strong>Status:</strong> <span class="status-registered">Înscris</span></p>
            
            <form @submit.prevent="handleConfirmPresence(event.id)" class="confirm-form">
              <label :for="'code-' + event.id">Introdu codul de prezență:</label>
              <input 
                type="text" 
                :id="'code-' + event.id" 
                v-model="confirmationCodes[event.id]" 
                placeholder="Codul primit la eveniment"
              />
              <button type="submit">Confirmă</button>
            </form>
            
            <p v-if="confirmMessages[event.id]" 
               :class="{ 'error-message': confirmErrors[event.id], 'success-message': !confirmErrors[event.id] }"
               class="confirm-message">
              {{ confirmMessages[event.id] }}
            </p>
          </div>
        </li>
      </ul>
      
      <p v-if="!loading && events.length === 0">Nu ești înscris la niciun eveniment viitor.</p>
    </div>
  </div>
</template>

<script setup>
// 1. Am scos 'defineExpose' și 'defineEmits' din import
import { ref, onMounted } from 'vue';
import apiClient from '@/api.js';

// 2. Am șters 'const emit = defineEmits(...)'.

const isOpen = ref(true); // 3. Am setat pe 'true' (ca să fie deschis by default)
const toggleOpen = () => { isOpen.value = !isOpen.value; };

const events = ref([]);
const loading = ref(true);
const error = ref('');
const confirmationCodes = ref({});
const confirmMessages = ref({});
const confirmErrors = ref({});

const formatData = (isoString) => {
  return new Date(isoString).toLocaleString('ro-RO', {
    dateStyle: 'medium',
    timeStyle: 'short'
  });
};

const fetchMyEvents = async () => {
  loading.value = true;
  try {
    const response = await apiClient.get('/profile/my-events');
    events.value = response.data;
    
  } catch (err) {
    console.error("Eroare la preluarea evenimentelor mele:", err);
    error.value = 'Nu am putut încărca evenimentele tale.';
  } finally {
    loading.value = false;
  }
};
onMounted(fetchMyEvents); 


const handleConfirmPresence = async (eventId) => {
  const code = confirmationCodes.value[eventId];
  
  if (!code) {
    confirmMessages.value[eventId] = 'Te rugăm să introduci un cod.';
    confirmErrors.value[eventId] = true;
    return;
  }

  confirmMessages.value[eventId] = 'Se confirmă...';
  confirmErrors.value[eventId] = false;

  try {
    const response = await apiClient.post(`/events/${eventId}/confirm-presence`, { 
      confirmation_code: code 
    });
    
    confirmMessages.value[eventId] = response.data.message;
    confirmErrors.value[eventId] = false;
    
    fetchMyEvents(); 
    
  } catch (err) {
    console.error("Eroare la confirmarea prezenței:", err);
    confirmMessages.value[eventId] = err.response?.data?.error || 'A apărut o eroare.';
    confirmErrors.value[eventId] = true;
  }
};
</script>

<style scoped>
/* Stilurile rămân identice */
.my-events-container { margin-top: 30px; }
.collapsible-header {
  cursor: pointer; display: flex; justify-content: space-between;
  align-items: center; border-bottom: 2px solid #007bff;
  padding-bottom: 10px; margin: 0;
}
.collapsible-header:hover { background-color: #f8f9fa; }
.collapsible-header span { font-size: 0.8em; }
.collapsible-content { padding-top: 20px; }
.event-list { list-style-type: none; padding: 0; }
.event-item {
  border: 1px solid #eee; background-color: #f9f9f9;
  padding: 15px; margin-bottom: 15px; border-radius: 8px;
}
.event-item h4 { margin-top: 0; color: #0056b3; }
.error { color: red; }
.status-attended { font-weight: bold; color: #28a745; }
.status-registered { font-weight: bold; color: #ffc107; }
.confirm-form { margin-top: 10px; display: flex; gap: 10px; }
.confirm-form input {
  flex-grow: 1; border: 1px solid #ccc;
  padding: 5px; border-radius: 4px;
}
.confirm-form button {
  background-color: #007bff; color: white; border: none;
  padding: 5px 10px; border-radius: 4px; cursor: pointer;
}
.confirm-message { margin-top: 10px; font-size: 0.9em; }
.success-message { color: green; }
.error-message { color: red; }
</style>